import { TFunction } from 'i18next';

export const getRoutePathname = (pathname: string, t: TFunction): string => {
  const pathnameSet = [
    { name: 'insights', value: t('INSIGHT_PAGE_TITLE') },
    { name: 'student-overview', value: t('STUDENT_OVERVIEW_PAGE_TITLE') },
    { name: 'student-advising', value: t('STUDENT_ADVISING_PAGE_TITLE') },
    { name: 'career-trends', value: t('CAREER_TRENDS_PAGE_TITLE') },
    { name: 'contact', value: t('CONTACT_US_PAGE_TITLE') },
    { name: 'faq', value: t('FAQ_PAGE_TITLE') },
  ];

  let result = '';

  pathnameSet.forEach((item) => {
    if (pathname.includes(item.name)) {
      result = item.value;
    }
  });

  return result;
};
